import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash-es';
import cx from 'classnames';
import { useStoreActions, useStoreState } from 'store';
import type { FamilyContact } from 'types/domain';

import ContactCardAccordion from '../components/ContactCardAccordion';
import FourNotFour from './FourNotFour';

import { AddressIcon, LocationIcon, OfficeIcon, ParentIcon } from '../assets/icons';
import styles from './ContactDetails.module.css';

const ContactDetails = () => {
  const { contactId } = useParams();
  const { contacts, loading, fetched, error } = useStoreState(state => state.contacts);
  const { getContacts } = useStoreActions(actions => actions.contacts);
  const { updatePageTitle } = useStoreActions((actions) => actions.globalUtils);

  const [expanded, setExpanded] = useState<number | false>(false);
  const [currentContact, setCurrentContact] = useState<FamilyContact | null>(null);
  
  useEffect(() => {
    if (currentContact?.familyHeadName) {
      updatePageTitle(`${currentContact.familyHeadName} Family`);
    }
    return () => {
      updatePageTitle('');
    };
  }, [currentContact, updatePageTitle]);

  useEffect(() => {
    if (isEmpty(contacts) && !fetched) {
      getContacts();
    }
    if (!isEmpty(contacts)) {
      const selectedContact = contacts.find(contact => Number(contact.id) === Number(contactId));
      setCurrentContact(selectedContact || null);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts, fetched, getContacts]);

  const handleAccordianChange = (panel: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  if (loading) {
    return (
      <div className={styles.loaderWrapper}>
        <div>Fetching Contacts...</div>
        <CircularProgress className={styles.progress} />
      </div>
    )
  }

  if (error) {
    return (<FourNotFour />)
  }

  return (
    <div className={styles.container}>
      <div className={styles.pageHeading}>Family Details:</div>
      {!isEmpty(currentContact?.gotraDetail) && (
        <div className={styles.detailWrapper}>
          <span className={styles.detailHeading}><ParentIcon className={styles.detailIcon} /> Gotra & Ancestor Place: </span>{currentContact?.gotraDetail}
        </div>
      )}
      <div className={styles.detailWrapper}>
        <span className={styles.detailHeading}><AddressIcon className={styles.detailIcon} /> Address: </span>{currentContact?.address}
      </div>
      {!isEmpty(currentContact?.occupationName) && (
        <>
          <div className={cx(styles.detailHeading, styles.occupationHeading)}><OfficeIcon className={styles.detailIcon} /> Occupation:</div>
          <div className={styles.occupationName}>{currentContact?.occupationName}</div>
          <div className={styles.occupationDesc}>{currentContact?.occupationDesciption}</div>
          <div><LocationIcon className={styles.detailIcon} /> {currentContact?.occupationAddress}</div>
        </>
      )}
      <div className={styles.pageHeading}>Family Members:</div>
      {currentContact?.familyDetails?.map((member) => (
        <ContactCardAccordion handleChange={handleAccordianChange} expanded={expanded} key={member.id} contact={member} />
      ))}
    </div>
  );
};

export default ContactDetails;